/**
 * @file Application.
 */

/**
 * Application functions.
 *
 * Runs js specific to the Application template.
 */
const vApplication = () => {
	import('../../components/form-switcher/form-switcher').then((m) =>
		m.default(),
	);
};

if (document.readyState !== 'loading') {
	vApplication();
} else {
	document.addEventListener('DOMContentLoaded', vApplication);
}
